import { ReactNode } from "react";

import { Button } from "@/components/elements/Button";

import styles from "./styles.module.css";

type CardUiButtonRightProps = {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
};
const CardUiButtonRight = ({
  children,
  onClick,
  disabled,
}: CardUiButtonRightProps) => {
  return (
    <Button
      className={styles.buyButtonMedia}
      size="small"
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default CardUiButtonRight;
